module.exports = __webpack_public_path__ + "img/student_linzeli.5d1ed251.png";